import Reveal from "./Reveal";
import { ArrowRight } from "lucide-react";
import { SITE } from "@/lib/site-data";

export default function BookingCTA() {
  return (
    <section
      id="book"
      data-testid="booking-cta-section"
      className="relative bg-[color:var(--sr-cream)] overflow-hidden"
      aria-label="Book your experience"
    >
      {/* Full-bleed background image */}
      <div className="absolute inset-0">
        <img
          src="/images/booking-bg.png"
          alt="A soft cream backdrop with a serum dropper releasing a drop"
          loading="lazy"
          className="w-full h-full object-cover"
          style={{ objectPosition: "left center" }}
        />
        {/* Fade the RIGHT half only so the dropper on the left stays fully visible */}
        <div className="absolute right-0 top-0 bottom-0 w-[60%] pointer-events-none bg-gradient-to-l from-[color:var(--sr-cream)] via-[color:var(--sr-cream)] to-transparent" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-40 grid lg:grid-cols-2 gap-10 items-center">
        {/* Left column intentionally empty on desktop to reveal the dropper */}
        <div className="hidden lg:block" aria-hidden="true" />

        <div>
          <Reveal>
            <p className="eyebrow eyebrow-dark">Ready to Glow?</p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] on-cream mt-3 tracking-[-0.01em]">
              Book Your
              <br />
              Experience Today
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-6 on-cream-muted text-[15px] leading-[1.85] max-w-[520px]">
              Your skin, lashes, and brows deserve intentional care. Reserve
              your appointment on my booking site — real-time availability,
              service menu, and pricing all in one place.
            </p>
          </Reveal>

          <Reveal delay={200}>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
              <a
                href={SITE.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="booking-cta-btn"
                className="btn-gold"
              >
                Book Now <ArrowRight size={14} strokeWidth={1.5} />
              </a>
              <span className="on-cream-muted text-[13px] tracking-wide">
                Opens skin-refinery-by-lacretia.comb.works
              </span>
            </div>
          </Reveal>

          <Reveal delay={260}>
            <p className="mt-10 on-cream-muted text-[12.5px] tracking-[0.18em] uppercase max-w-[520px]">
              Virtual consultations coming soon — a custom questionnaire will
              be added here when we launch.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
